import { RootState } from '..';

export const coordinatorSelector = (state: RootState) => state.coordinator;

export const pendingOrdersOptionsSelector = (state: RootState) =>
  state.coordinator.pendingOrdersOptions;
